import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    waitingFlag:false,// 请求等待遮罩
    confirmToast:{
      onOff:false,
      text:' '
    },// 对话框提示
    AppTopTip:{
      onOff:false,
      text:''
    },// 顶部提示
    LoadingOnOff:false,
  },
  getters: {
    getState: (state) => (param) => {
      return state[param];
    }
  },
  actions: {
    setState:(context,obj)=>{
      context.commit('setState',obj);
      if(obj.name=='AppTopTip'){
        setTimeout(function(){
          context.commit('setState',{"name":'AppTopTip','value':{onOff:false,text:''}})
        },2500)
      }
    }
  },
  mutations: {
    setState:(state,obj)=>{
      state[obj.name]=obj.value;
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js